import React from 'react';
export function Header() {
  return <header className="h-[80px] w-full" data-id="element-123">
      <div className="max-w-[1200px] mx-auto h-full px-8 flex items-center" data-id="element-124"></div>
    </header>;
}